import { render, staticRenderFns } from "./_Upload.vue?vue&type=template&id=c8a29704&scoped=true"
import script from "./_Upload.vue?vue&type=script&lang=ts"
export * from "./_Upload.vue?vue&type=script&lang=ts"
import style0 from "./_Upload.vue?vue&type=style&index=0&id=c8a29704&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a29704",
  null
  
)

export default component.exports